{
	"title": "Nieuwsbrief",
	"description": "Wie zich in de shop heeft aangemeld voor de nieuwsbrief.",
	"count": {
		"label": "Aanmeldingen",
		"help": "Actieve aanmeldingen. Wie zich heeft afgemeld, telt niet mee."
	},
	"export": {
		"title": "Exporteren",
		"description": "Een CSV-bestand met e-mailadres, moment van aanmelden en bron, voor je nieuwsbriefprogramma. Afgemelde adressen staan er niet in.",
		"button": "CSV downloaden",
		"busy": "Bezig met downloaden…",
		"failed": "Downloaden lukte niet. Probeer het opnieuw."
	},
	"welcome": {
		"title": "Welkomstcode",
		"description": "Wie zich aanmeldt, krijgt per mail een eigen kortingscode die één keer werkt. Elk e-mailadres krijgt hem maar één keer, ook als het zich afmeldt en later opnieuw aanmeldt. De codes staan bij Kortingscodes.",
		"enabled": "Welkomstcode versturen",
		"enabledDescription": "Staat dit uit, dan krijgen nieuwe aanmeldingen geen code en geen welkomstmail.",
		"kind": "Soort korting",
		"kinds": {
			"percentage": "Percentage",
			"fixedAmount": "Vast bedrag",
			"freeShipping": "Gratis verzending"
		},
		"percent": "Percentage",
		"amount": "Bedrag in euro",
		"freeShippingDescription": "De klant betaalt geen verzendkosten.",
		"validityDays": "Geldig (dagen)",
		"validityDaysDescription": "Vanaf het moment van aanmelden, 1 tot 365 dagen.",
		"minimumOrderAmount": "Minimum orderbedrag in euro",
		"minimumOrderAmountDescription": "Laat leeg voor geen minimum.",
		"save": "Opslaan",
		"changed": "Iemand anders heeft deze instellingen net opgeslagen. Laad ze opnieuw en pas ze dan aan.",
		"reload": "Opnieuw laden",
		"showCodes": "Welkomstcodes bekijken"
	},
	"help": {
		"newsletter": {
			"title": "Nieuwsbrief",
			"area": "Content › Nieuwsbrief",
			"short": "Klanten melden zich in de shop aan: onderaan elke pagina, op de home, bij het afrekenen en in hun account. Het vinkje staat nooit vooraf aan. De nieuwsbrief zelf verstuur je met je eigen programma.",
			"terms": ["newsletter:signups", "newsletter:export", "newsletter:welcome"]
		},
		"signups": {
			"title": "Aanmeldingen",
			"area": "Content › Nieuwsbrief",
			"short": "Het aantal adressen dat nu is aangemeld; elk adres telt één keer. Afmelden kan met de link in de welkomstmail of met de schakelaar in het account. Meldt iemand zich opnieuw aan, dan telt hij weer mee."
		},
		"export": {
			"title": "Exporteren",
			"area": "Content › Nieuwsbrief",
			"short": "Een CSV-bestand met de aangemelde adressen, het moment van aanmelden en de bron: checkout, account of footer (het formulier onderaan de pagina's en op de home). Dat bestand zet je in je nieuwsbriefprogramma.",
			"warning": "Exporteer vlak voor je een nieuwsbrief verstuurt, en vervang de lijst in je programma. Wie zich in de shop heeft afgemeld, staat er dan niet meer in.",
			"terms": ["newsletter:signups"]
		},
		"welcome": {
			"title": "Welkomstcode",
			"area": "Content › Nieuwsbrief",
			"short": "Een nieuw aangemeld adres krijgt per mail een eigen kortingscode die één keer werkt. Eén per canoniek adres: wie zich afmeldt en opnieuw aanmeldt, of een alias van dezelfde inbox gebruikt, krijgt geen tweede.",
			"warning": "Wat je hier verandert, geldt voor nieuwe aanmeldingen. Codes die al verstuurd zijn, blijven zoals ze waren.",
			"terms": ["newsletter:canonicalEmail", "newsletter:kind", "newsletter:minimumOrderAmount"],
			"goTo": {
				"to": "/discount-code",
				"label": "Naar Kortingscodes"
			}
		},
		"canonicalEmail": {
			"title": "Canoniek adres",
			"area": "Content › Nieuwsbrief",
			"short": "De inbox achter een e-mailadres: kleine letters, zonder +label, en bij Gmail zonder punten. Zo zijn Jan.Jansen+shop@gmail.com en janjansen@gmail.com één adres. De mail gaat wel naar het adres zoals het getypt is."
		},
		"kind": {
			"title": "Korting van de welkomstcode",
			"area": "Content › Nieuwsbrief › Welkomstcode",
			"short": "Wat de welkomstcode van de bestelling afhaalt: een percentage, een vast bedrag of gratis verzending. Het werkt als bij elke kortingscode: de klant typt de code in de mand, en er past één code op een bestelling.",
			"warning": "Een product met een klantprijs krijgt geen korting van een code.",
			"terms": ["discountCode:kind", "customer:customerPrice"]
		},
		"minimumOrderAmount": {
			"title": "Minimum orderbedrag",
			"area": "Content › Nieuwsbrief › Welkomstcode",
			"short": "De code werkt pas als de producten in de mand samen minstens dit bedrag kosten, zonder de verzendkosten. Een zakelijke klant rekent zonder btw, een consument met. Leeg: geen minimum."
		}
	},
	"helpExample": {
		"signup": {
			"label": "Het nieuwsbriefblok op de home van de shop: de kop, de regel {{text}}, een veld voor het e-mailadres, de knop Aanmelden en een vinkje dat uit staat."
		},
		"welcome": {
			"sandbox": "Kies de welkomstcode en zie wat de shop belooft.",
			"enabled": "Welkomstcode aan",
			"kind": "Soort korting",
			"minimum": "Minimum",
			"noMinimum": "Geen",
			"home": "Op de home",
			"done": "Na het aanmelden",
			"shopLabel": "Op de home: {{home}}",
			"doneLabel": "Na het aanmelden zegt de shop: {{done}}",
			"value": "Korting"
		}
	}
}
